var swiper = new Swiper(".dealSliders", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView:1.4,
        spaceBetween:8,
      },
      768: {
        slidesPerView:3,
        spaceBetween:20,
      },
      1024: {
        slidesPerView:4,
        spaceBetween:30,
      },
    },
  });